import { Component, inject } from '@angular/core';
import { TitleChange } from '../services/title-change';
import { Link } from '../directives/link';

@Component({
  selector: 'app-die-for-a-lie',
  imports: [Link],
  templateUrl: './die-for-a-lie.html',
  styleUrl: './die-for-a-lie.scss',
})
export class DieForALie {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Die for a Lie`);
    this.dynamicTitle.description(`Many people claim the disciples would die for a lie. Only two deaths are in the New Testament the remaining stories are found in apocrypha or Church history written much later.`);
  }
}
